import angular from "angular";

angular
    .module('app')
    .component('individualAttachStudents', {
        template: require('./individual-attach-students.html'),
        controller: ['$http', 'Notifier', '$uibModal', 'moment', '$timeout', controller],
        bindings: {
            course: '<'
        }
    });

function controller($http, Notifier, $uibModal, moment, $timeout) {

    let $ctrl = this;

    $ctrl.page = 1;

    $ctrl.search = null;

    $ctrl.totalSelect = false;

    $ctrl.selectedStudents = [];

    $ctrl.$onInit = function () {

        $ctrl.getList();
    };

    $ctrl.getList = function () {
        $http
            .get(`/admin/users/get-list-with-course-status`, {
                params: {
                    page: $ctrl.page,
                    search: $ctrl.search,
                    course_id: $ctrl.course.id,
                }
            })
            .then(
                function (response) {
                    $ctrl.students = response.data.data;

                    $ctrl.total = response.data.total;
                    $ctrl.students.forEach(function (student) {
                        let exists = $ctrl.selectedStudents.find(v => v.id == student.id);
                        student.isSelected = !!exists;
                    });
                },
                function (error) {

                }
            );
    };

    $ctrl.reset = function () {
        $ctrl.page = 1;
        $ctrl.search = null;
        $ctrl.getList();
    };

    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.pageChanged = function () {
        $ctrl.totalSelect = false;
        $ctrl.getList();
    };

    $ctrl.userSelected = function (student) {
        if (student.isSelected) {
            $ctrl.selectedStudents.push(student);
        } else {
            delStudentFromSelected(student);
        }
    };

    $ctrl.totalSelectChanged = function () {
        if ($ctrl.totalSelect) {
            $ctrl.students.forEach(function (student) {
                if (!student.course_status && !student.isSelected) {
                    student.isSelected = true;
                    $ctrl.selectedStudents.push(student);
                }
            });
        } else {
            $ctrl.students.forEach(function (student) {
                if (!student.course_status && student.isSelected) {
                    student.isSelected = false;
                    delStudentFromSelected(student);
                }
            });
        }
    };

    function delStudentFromSelected(student) {
        let existsInd = $ctrl.selectedStudents.findIndex(v => v.id == student.id);
        if (existsInd != -1) {
            $ctrl.selectedStudents.splice(existsInd, 1);
        }
    }

    $ctrl.openConfirmModal = function () {
        $uibModal
            .open({
                component: 'individualConfirmStudentsAttachModal',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    course: function () {
                        return $ctrl.course;
                    },
                    students: function () {
                        return $ctrl.selectedStudents;
                    }
                }
            })
            .result
            .then(
                function () {
                    $ctrl.totalSelect  = false;
                    $ctrl.selectedStudents.forEach(s => s.isSelected = false);
                    $ctrl.selectedStudents = [];
                },
                function () {
                }
            );
    };

}
